"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Description = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledDescription = styled_components_1.default.p `
	white-space: pre-line;
	font-size: ${({ theme }) => theme.baseFontSize};
	text-align: center;
	letter-spacing: 0;
	color: ${({ theme }) => theme.textBlack};
	width: 90%; // ie-text-wrap - compatibility with IE

	@media (max-width: 41em) {
		margin: 10px 20px;
		font-size: ${({ theme }) => theme.smallFontSize};
	}
`;
;
const Description = ({ children, dataTestId, dangerouslySetInnerHTML }) => {
    return (!!dangerouslySetInnerHTML ?
        react_1.default.createElement(StyledDescription, { dangerouslySetInnerHTML: { __html: dangerouslySetInnerHTML }, "data-testid": dataTestId }) :
        react_1.default.createElement(StyledDescription, { "data-testid": dataTestId }, children));
};
exports.Description = Description;
